// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-verification-container {
  display: grid;
  gap: 8px;
  align-items: center;
  justify-items: center;
  margin-top: 20px;
}

.auth-verification-container input[type="text"] {
  border: none;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  padding: 12px;
  margin: 12px 0;
  border-radius: 8px;
  text-align: center;
  height: 6vh;
  width: 100%;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.auth-verification-container button[type="submit"]:focus {
  outline: none;
  box-shadow: 0 0 2px 2px #4CAF50;
}

.auth-verification-container button[type="submit"]:hover {
  background-color: #3e8e41;
}

.auth-verification-container button[type="submit"]:focus {
  outline: none;
  box-shadow: 0 0 2px 2px #4CAF50;
}

.auth-verification-container button[type="submit"] {
  font-size: 16px;
  font-weight: bold;
  border: none;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  padding: 12px;
  margin: 12px 0;
  border-radius: 8px;
  text-align: center;
  width: 100%;
  background-color: var(--theme-consistent);
  color: white;
  max-width: 100vw;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  margin: 0px;
}

.auth-verification-container button[type="submit"]:active {
  transform: scale(0.98);
  box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
}

.auth-verification-container button[type="submit"]:hover {
  background-color: var(--theme-consistent);
}

.twofactorauth-form {
  display: grid;
  padding: 8px;
  font-size: 1.5rem;
  color: var(--text-primary);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  gap: 0px;
}

.twofactorauth-form p {
  font-size: 1rem;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  margin: 0px;
}

.twofactorauth-error {
  color: #e74c3c; /* Red color for error */
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  margin-top: 24px;
  background-color: #f5d1d1;
}

.totpSecret {
  font-weight: bolder;
  font-size: 12px;
}

.totp-secret-container {
  text-align: center;
  color: var(--text-primary);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.secret-box {
  display: inline-flex;
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  min-width: 100px;
  justify-content: center;
  align-items: center;
}

.secret-box.copied {
  background-color: var(--theme-consistent);
  color: #fff;
}

.secret-content {
  font-weight: bolder;
  font-size: 12px;
}


/* Mobile devices */
@media only screen and (max-width: 767px) {
  .auth-verification-container input[type="text"] {
    height: 8vh;
  }
}

/* Tablets */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .auth-verification-container input[type="text"] {
    height: 7vh;
  }
}

/* Computers */
@media only screen and (min-width: 1024px) {
  .auth-verification-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
  }

  .auth-verification-container input[type="text"] {
    height: 6vh;
    width: 400px;
    max-width: 100%;
    margin: 12px 0;
  }

  .auth-verification-container button[type="submit"] {
    height: 6vh;
    width: 400px;
    max-width: 100%;
    margin: 24px 0;
  }

  .twofactorauth-error {
    margin-top: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/TwoFactorAuth.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,2CAA2C;EAC3C,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,cAAc,EAAE,wBAAwB;EACxC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;;AAGA,mBAAmB;AACnB;EACE;IACE,WAAW;EACb;AACF;;AAEA,YAAY;AACZ;EACE;IACE,WAAW;EACb;AACF;;AAEA,cAAc;AACd;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".auth-verification-container {\n  display: grid;\n  gap: 8px;\n  align-items: center;\n  justify-items: center;\n  margin-top: 20px;\n}\n\n.auth-verification-container input[type=\"text\"] {\n  border: none;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  padding: 12px;\n  margin: 12px 0;\n  border-radius: 8px;\n  text-align: center;\n  height: 6vh;\n  width: 100%;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.auth-verification-container button[type=\"submit\"]:focus {\n  outline: none;\n  box-shadow: 0 0 2px 2px #4CAF50;\n}\n\n.auth-verification-container button[type=\"submit\"]:hover {\n  background-color: #3e8e41;\n}\n\n.auth-verification-container button[type=\"submit\"]:focus {\n  outline: none;\n  box-shadow: 0 0 2px 2px #4CAF50;\n}\n\n.auth-verification-container button[type=\"submit\"] {\n  font-size: 16px;\n  font-weight: bold;\n  border: none;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  padding: 12px;\n  margin: 12px 0;\n  border-radius: 8px;\n  text-align: center;\n  width: 100%;\n  background-color: var(--theme-consistent);\n  color: white;\n  max-width: 100vw;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  margin: 0px;\n}\n\n.auth-verification-container button[type=\"submit\"]:active {\n  transform: scale(0.98);\n  box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);\n}\n\n.auth-verification-container button[type=\"submit\"]:hover {\n  background-color: var(--theme-consistent);\n}\n\n.twofactorauth-form {\n  display: grid;\n  padding: 8px;\n  font-size: 1.5rem;\n  color: var(--text-primary);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  gap: 0px;\n}\n\n.twofactorauth-form p {\n  font-size: 1rem;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  margin: 0px;\n}\n\n.twofactorauth-error {\n  color: #e74c3c; /* Red color for error */\n  font-size: 16px;\n  font-weight: bold;\n  text-align: center;\n  padding: 10px;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  margin-top: 24px;\n  background-color: #f5d1d1;\n}\n\n.totpSecret {\n  font-weight: bolder;\n  font-size: 12px;\n}\n\n.totp-secret-container {\n  text-align: center;\n  color: var(--text-primary);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.secret-box {\n  display: inline-flex;\n  padding: 8px 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  min-width: 100px;\n  justify-content: center;\n  align-items: center;\n}\n\n.secret-box.copied {\n  background-color: var(--theme-consistent);\n  color: #fff;\n}\n\n.secret-content {\n  font-weight: bolder;\n  font-size: 12px;\n}\n\n\n/* Mobile devices */\n@media only screen and (max-width: 767px) {\n  .auth-verification-container input[type=\"text\"] {\n    height: 8vh;\n  }\n}\n\n/* Tablets */\n@media only screen and (min-width: 768px) and (max-width: 1023px) {\n  .auth-verification-container input[type=\"text\"] {\n    height: 7vh;\n  }\n}\n\n/* Computers */\n@media only screen and (min-width: 1024px) {\n  .auth-verification-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-top: 40px;\n  }\n\n  .auth-verification-container input[type=\"text\"] {\n    height: 6vh;\n    width: 400px;\n    max-width: 100%;\n    margin: 12px 0;\n  }\n\n  .auth-verification-container button[type=\"submit\"] {\n    height: 6vh;\n    width: 400px;\n    max-width: 100%;\n    margin: 24px 0;\n  }\n\n  .twofactorauth-error {\n    margin-top: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
